'use strict';

/**
 * accordionAnimate
 * @description
 */
function accordionAnimate() {
  let accordionItems = document.querySelectorAll('button.accordion-item-title--button');
  accordionItems.forEach(function(item) {
    item.addEventListener('click', function(e) {
      e.preventDefault();
      let thisitem = jQuery(this);
      let parent = thisitem.closest('.accordion-item');
      let title = parent.children('div.accordion-item-title')
      let body = parent.children('.accordion-body');

      if (jQuery(this).attr('aria-expanded') === 'false') {
        parent.removeClass('collapsed').addClass('expanded');
        title.removeClass('title-closed').addClass('title-open');
        body.attr('aria-hidden', 'false');
        body.removeClass('body-closed').addClass('body-open');
        thisitem.attr('aria-expanded', 'true');
      } else {
        parent.removeClass('expanded').addClass('collapsed');
        title.removeClass('title-open').addClass('title-closed')
        body.attr('aria-hidden', 'true');
        body.removeClass('body-open').addClass('body-closed');
        thisitem.attr('aria-expanded', 'false');
      }
    });
  });
}

function initAccordion() {
  jQuery(document).ready( function() {
    accordionAnimate();
  });
}

export {initAccordion};

